import { useQuery, keepPreviousData } from '@tanstack/react-query'
import { useRouter } from 'next/router'
import { SearchResult } from '@/src/types/api-types'
import {
  fetchSearchProducts,
  searchProductsQueryKey,
} from '@/lib/hook/useSearchProductRest'
import { SearchProductsArgs } from '@/lib/searchProductsTransform'

type Options = {
  enabled?: boolean
}

// Hook one-shot pour les consommateurs simples de SEARCH_PRODUCTS
// (RecommendSection, PopupCabasStore, AsloBoughtProducts, CompanyBestSellerProducts,
// SacherieWefold). Remplace les useQuery Apollo(QUERIES.CATALOG.SEARCH_PRODUCTS)
// en reutilisant l'infra REST du lot 7 (fetchSearchProducts + searchProductsTransform).
//
// Retourne le meme SearchResult que l'ancien data?.searchProducts pour que les
// consommateurs continuent a lire data?.products / data?.params / data?.discount.
const useSearchProductsQuery = (
  args: SearchProductsArgs,
  options: Options = {}
): { data: SearchResult | undefined; loading: boolean } => {
  const router = useRouter()
  const locale = (router.query.locale as string) || 'fr'

  const { data, isLoading } = useQuery<SearchResult>({
    queryKey: searchProductsQueryKey('searchProducts', args),
    queryFn: () => fetchSearchProducts(args, { locale }),
    enabled: options.enabled ?? true,
    placeholderData: keepPreviousData,
  })

  return { data, loading: isLoading }
}

export default useSearchProductsQuery
